import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { Field, ErrorMessage } from "formik";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import axios from "axios";

const CMSFormTelephone = forwardRef(({ name, label,smallDescription, required, form, errorState, setErrorState, ...props }, ref) => {
  const [state, setState] = useState("ae");
  const [telephoneValid, setTelephoneValid] = useState(true);
  const [preferredCountries] = useState(["lb"]);
  const wrapperRef = useRef(null);

  // Expose scrollIntoView & focus to parent
  useImperativeHandle(ref, () => ({
    scrollIntoView: () => {
      wrapperRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    focus: () => {
      wrapperRef.current?.querySelector("input")?.focus();
    },
  }));

  const fetchDialCode = () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        if (response.data?.country) {
          setState(response.data.country.toLowerCase());
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (!form.values[name]) {
      fetchDialCode();
    }
  }, []);

  const setValidity = (valid, setFieldError) => {
    setTelephoneValid(valid);
    setErrorState?.(!valid);
    if (!valid) {
      setFieldError(name, "Please enter a valid number");
    }
  };

  const processNumber = (isValid, phone) => phone;

  return (
    <div ref={wrapperRef} className="form-group relative w-full flex flex-col">
      <label
        htmlFor={name}
        className={`text-[19px] lg:text-21pt  text-green text-nowrap  ${
          required ? "required" : "notRequired"
        } ${form.touched[name] && form.errors[name] ? "isInvalidText" : ""}`}
      >
        {label} <span className="text-16pt">{smallDescription}</span>{required  && <span className="text-20pt text-orange">*</span>}
      </label>

      <Field name={name}>
        {({
          field: { value },
          form: { setFieldTouched, setFieldValue, setFieldError },
        }) => (
          <IntlTelInput
            {...props}
            containerClassName="intl-tel-input w-full mt-1"
            inputClassName={`normal form-control font-mono  w-full h-[56px] text-18pt focus:outline-none focus:ring-2 focus:ring-green focus:ring-opacity-50 p-2 mt-1 border border-green rounded-[15px]`}
            defaultCountry={state || "ae"}
            preferredCountries={preferredCountries}
            value={value}
            nationalMode={false}
            autoHideDialCode={false}
            onPhoneNumberBlur={(isValid) => {
              setFieldTouched(name, true);
              setValidity(isValid, setFieldError);
            }}
            onPhoneNumberChange={(isValid, phone, country) => {
              setFieldValue(name, processNumber(isValid, phone, country));
              setValidity(isValid, setFieldError);
            }}
          />
        )}
      </Field>

      {form.touched[name] && form.errors[name] && (
        <span className="errorMessage">
          <ErrorMessage name={name} />
        </span>
      )}
      {form.touched[name] && !form.errors[name] && !telephoneValid && (
        <span className="errorMessage">Please enter a valid phone number</span>
      )}
    </div>
  );
});

export default CMSFormTelephone;
